export const SCHEDULER_USER = "Scheduler User"
export const SCHEDULER_ADMIN = "Scheduler Admin"
